import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import FlywheelCompleted from './flywheel/flywheelcompleted'
import CloudwaysCompleted from './cloudways/cloudwayscompleted'
import WPEngineCompleted from './wpengine/wpenginecompleted'
import WPCOMCompleted from './wpcom/wpcomcompleted'
import PressableCompleted from './pressablecompleted'
import MgCompleted from './mg/mgcompleted'

class Completed extends React.PureComponent {
	render() {
		const { migrate, canUpsell, task, actions, match } = this.props
		switch (migrate.get('origin')) {
		case ORIGIN.FLYWHEEL:
			return <FlywheelCompleted migrate={migrate} />
		case ORIGIN.CLOUDWAYS:
			return <CloudwaysCompleted migrate={migrate} />
		case ORIGIN.WPENGINE:
			return <WPEngineCompleted migrate={migrate} />
		case ORIGIN.AUTOMATTIC:
			return <WPCOMCompleted migrate={migrate} />
		case ORIGIN.PRESSABLE:
			return <PressableCompleted migrate={migrate} actions={actions} match={match} />
		default:
			return <MgCompleted task={task} migrate={migrate} canUpsell={canUpsell} />
		}
	}
}

Completed.propTypes = {
	migrate: ImmutablePropTypes.map,
	canUpsell: PropTypes.bool,
	task: ImmutablePropTypes.map,
	actions: PropTypes.object,
	match: PropTypes.object
}

export default Completed
